import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "alerts" }

import { computed } from 'vue';
import { useStore } from 'vuex';
import { ShiftCMSState } from '@/store';
import { Notification } from '@/models/notification.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppNotifications',
  setup(__props) {

const store = useStore<ShiftCMSState>();

const showNotification = computed<boolean>(
  () => store.getters.showNotification,
);
const notifications = computed<Notification[]>(() => store.state.notifications);

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notifications.value, (n) => {
      return (_openBlock(), _createBlock(_component_v_alert, {
        class: "mt-4",
        modelValue: showNotification.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showNotification).value = $event)),
        density: "compact",
        elevation: "4",
        type: n.type,
        key: n.message
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(n.message), 1)
        ]),
        _: 2
      }, 1032, ["modelValue", "type"]))
    }), 128))
  ]))
}
}

})